var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { Events, POSITIONS } from '../../plugin';
import OptionsIcon from '../common/optionsIcon';

var PlaybackRate = function (_OptionsIcon) {
  _inherits(PlaybackRate, _OptionsIcon);

  _createClass(PlaybackRate, null, [{
    key: 'pluginName',
    get: function get() {
      return 'playbackRate';
    }
    // 默认配置信息

  }, {
    key: 'defaultConfig',
    get: function get() {
      return {
        position: POSITIONS.CONTROLS_RIGHT,
        index: 4,
        list: [2, 1.5, 1, 0.75, 0.5],
        className: 'xgplayer-playbackrate',
        hidePortrait: false
      };
    }
  }]);

  function PlaybackRate(args) {
    _classCallCheck(this, PlaybackRate);

    var _this = _possibleConstructorReturn(this, (PlaybackRate.__proto__ || Object.getPrototypeOf(PlaybackRate)).call(this, args));

    _this.curRate = 1;
    return _this;
  }

  _createClass(PlaybackRate, [{
    key: 'beforeCreate',
    value: function beforeCreate(args) {
      var playbackRate = args.player.config.playbackRate;

      var list = !playbackRate ? [] : Array.isArray(playbackRate) ? playbackRate : args.config.list;
      if (Array.isArray(list)) {
        args.config.list = list.map(function (item) {
          if (typeof item === 'number') {
            item = {
              rate: item,
              text: item + 'x'
            };
          } else if (!item.text && item.rate) {
            item.text = item.rate + 'x';
          }
          return item;
        });
      }
    }
  }, {
    key: 'afterCreate',
    value: function afterCreate() {
      var _this2 = this;

      _get(PlaybackRate.prototype.__proto__ || Object.getPrototypeOf(PlaybackRate.prototype), 'afterCreate', this).call(this);
      this.on(Events.RATE_CHANGE, function () {
        if (_this2.curValue === _this2.player.playbackRate) {
          return;
        }
        _this2.renderItemList();
      });
    }
  }, {
    key: 'show',
    value: function show() {
      if (!this.config.list || this.config.list.length === 0) {
        return;
      }
      _get(PlaybackRate.prototype.__proto__ || Object.getPrototypeOf(PlaybackRate.prototype), 'show', this).call(this);
    }
  }, {
    key: 'onItemClick',
    value: function onItemClick(e, data) {
      _get(PlaybackRate.prototype.__proto__ || Object.getPrototypeOf(PlaybackRate.prototype), 'onItemClick', this).apply(this, arguments);
      var target = e.delegateTarget;
      var rate = target.getAttribute('rate');
      if (Number(rate) === this.curValue) {
        return false;
      }
      this.curValue = Number(rate);
      this.player.playbackRate = Number(rate);
    }
  }, {
    key: 'renderItemList',
    value: function renderItemList() {
      var _this3 = this;

      var playbackRate = this.player.playbackRate || 1;
      this.curValue = playbackRate;
      var curIndex = 0;
      var items = this.config.list.map(function (item, index) {
        var itemInfo = {
          rate: item.rate
        };
        if (itemInfo.rate === playbackRate) {
          itemInfo.isCurrent = true;
          curIndex = index;
        }
        itemInfo.showText = _this3.getTextByLang(item);
        return itemInfo;
      });
      _get(PlaybackRate.prototype.__proto__ || Object.getPrototypeOf(PlaybackRate.prototype), 'renderItemList', this).call(this, items, curIndex);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      _get(PlaybackRate.prototype.__proto__ || Object.getPrototypeOf(PlaybackRate.prototype), 'destroy', this).call(this);
    }
  }]);

  return PlaybackRate;
}(OptionsIcon);

export default PlaybackRate;